<mat-icon *ngIf="!isActive; else existedAttributes" class="attributes-button" matTooltip="{{hint}}">
    {{notActiveIcon||activeIcon}}</mat-icon>

<ng-template #existedAttributes>
    <mat-icon class="attributes-button active-icon" matTooltip="{{hint}}">{{activeIcon}}</mat-icon>
</ng-template>
